export const LOGGER = 'logging-service';
export const ENVIRONMENT = 'environment';
